export default "<img src=\"../../../assets/loading2.gif\">\n<div mat-dialog-content>Loading ...</div>"